import type { ReactNode } from 'react'
import logo from '../../assets/logo.svg'
import logoIcon from '../../assets/logo-icon.svg'

type Props = {
  title: string
  subtitle: string
  footer?: ReactNode
  children?: ReactNode
}

export default function AuthCard({ title, subtitle, footer, children }: Props) {
  return (
    <main className="flex min-h-dvh flex-col bg-stone-100 px-4 py-5 sm:px-8 sm:py-7">
      <img src={logo} alt="Adlovin" className="h-6 w-auto self-center sm:self-start" />

      <div className="flex flex-1 items-center justify-center py-8">
        <div className="w-full max-w-lg rounded-3xl border border-white bg-white bg-[radial-gradient(110%_75%_at_100%_0%,rgba(173,96,255,0.13)_0%,rgba(255,255,255,0)_70%)] p-6 shadow-[0_2px_6px_rgba(28,25,23,0.04),0_32px_64px_-24px_rgba(28,25,23,0.22)] sm:p-9">
          <header className="flex items-center gap-4">
            <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-white shadow-[0_1px_3px_rgba(28,25,23,0.08)] ring-1 ring-stone-200/70">
              <img src={logoIcon} alt="" className="w-7" />
            </span>
            <div>
              <h1 className="text-[22px] leading-tight font-semibold tracking-[-0.02em] text-stone-900 sm:text-2xl">
                {title}
              </h1>
              <p className="mt-1 text-[15px] text-stone-500">{subtitle}</p>
            </div>
          </header>

          {children && <div className="mt-8">{children}</div>}

          {footer && <p className="mt-7 text-center text-[15px] text-stone-500">{footer}</p>}
        </div>
      </div>
    </main>
  )
}
